export default {

    authSuccess: (state, access_token) => {
        state.access_token = access_token;
    },
    authError: (state, err) => {
    /* let errors=err.errors?err.errors:{};
        if(err.error=="invalid_credentials"){
            errors.invalid_credentials=['The user credentials were incorrect.'];
        }

        state.status = 'error';
        state.hasLoadedOnce = true;
        state.errors.record(errors);*/
    },
    authLogout: (state) => {
        state.access_token = '';
    },

    setAdmRoles: (state, value) => {
      state.admRoles = value;
    },
    saveLoginData: (state, loginData) => {
        state.pendingLoginData = loginData;
    },
    clearLoginData: (state) => {
        state.pendingLoginData = null;
    },
    setRefreshToken: (state, refresh_token) => {
        state.refresh_token = refresh_token;
    }
}